<template>
  <div class="bni">
    <div class="bni-card">
      <div class="bni-title">{{ $t('paymentInformation') }}</div>
      <div class="">
        <div class="item">
          <div class="title">{{ $t('accountName') }}</div>
          <div class="value"></div>
          <div class="value">
            {{ type === 'bca' ? 'PT KREDIT PINTAR INDONESIA' : bankInfo.accountName || '-' }}
          </div>
        </div>
        <div class="item">
          <div class="title">{{ $t('accountNumber') }}</div>
          <div class="value">
            {{ (type === 'bca' ? bankInfo.vaNumber : bankInfo.accountNumber) || '-' }}
          </div>
        </div>
        <div class="item">
          <div class="title">{{ $t('bankName') }}</div>
          <div class="value">
            {{ type === 'bca' ? 'BCA（Bank Central Asia）' : bankInfo.name || '-' }}
          </div>
        </div>
        <div class="item">
          <div class="title">{{ $t('branchName') }}</div>
          <div class="value">
            {{ type === 'bca' ? '014' : bankInfo.code || '-' }}
          </div>
        </div>
      </div>
    </div>
    <div class="split-block"></div>
    <div class="bni-card">
      <div class="bni-title">{{ $t('paymentMethod') }}</div>
      <div class="">
        <div class="item method">
          <div class="serial">1</div>
          <div class="desc">{{ $t('transferDesc1') }}</div>
        </div>
        <div class="item method">
          <div class="serial">2</div>
          <div class="desc">{{ $t('transferDesc2') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  i18n: {
    messages: {
      en: {
        accountName: 'Account Name',
        accountNumber: 'Account Number',
        bankName: 'Bank Name',
        branchName: 'Bank Code',
        paymentInformation: 'Payment Information',
        paymentMethod: 'Payment Method',
        transferDesc1: 'Transfer money to the account above.',
        transferDesc2: 'After you transfer, your balance will be updated soon.',
        VANumber: 'VA Number',
      },
      id: {
        accountName: 'Nama Pemilik Akun',
        accountNumber: 'No. Rekening',
        bankName: 'Nama Bank',
        branchName: 'Kode Bank',
        paymentInformation: 'Informasi Pembayaran',
        paymentMethod: 'Metode Pembayaran',
        transferDesc1: 'Transfer uang ke akun di atas.',
        transferDesc2: 'Setelah Anda transfer, nominal Anda akan diperbarui segera',
        VANumber: 'VA Number',
      },
    },
  },
  components: {},
  data() {
    return {
      type: this.$route.query.type,
      bankInfo: {},
    }
  },
  mounted() {
    if (this.$route.name === 'UserTopup') {
      this.getAccountInfo()
    }
  },
  methods: {
    async getAccountInfo() {
      const url = `/invested-payment-api/payment/${this.type === 'bca' ? 4 : 3}/invoice`
      const payload = {
        referenceId: this.$store.state.userInfo.id,
        amount: Number(this.$route.query.amount),
        currencyType: 'IDR',
      }
      const response = await this.$http.post(url, payload)
      const data = response.data.data
      this.bankInfo = this.type === 'bca' ? data : (data && data.bankInfo ? data.bankInfo : {})
    },
  },
}
</script>

<style lang="stylus" scoped>
.bni-card {
  padding: 30px 20px;
}

.bni-title {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
  color: #101010;
}

.item {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: baseline;
  font-size: 14px;
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }

  .title {
    color: #555;
    margin-bottom: 8px;
  }
  .value {
    font-weight: 500;
  }
  .serial {
    background: #5cc414;
    margin-right: 32px;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    color: #ffffff;
  }
  .desc {
    width: calc(100vw - 324px);
    line-height: 24px;
  }
  &.method {
    flex-direction: row;
    .serial {
      margin-right: 12px;
      width: 20px;
      height: 20px;
      font-size: 14px;
    }
    .desc {
      width: calc(100vw - 80px);
      font-size: 14px;
    }
  }
}

.split-block {
  background-color: #f8f8f8;
  height: 6px;
}
</style>
